import { render, staticRenderFns } from "./BannerComponent.vue?vue&type=template&id=3aef6504&scoped=true&"
import script from "./BannerComponent.vue?vue&type=script&lang=js&"
export * from "./BannerComponent.vue?vue&type=script&lang=js&"
import style0 from "./BannerComponent.vue?vue&type=style&index=0&id=3aef6504&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aef6504",
  null
  
)

export default component.exports